import { useMutation } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { authMutationKeys } from '../constants'

export const useLoginResetPasswordMutation = () => {
  const handleMutation = async ({ email }) => {
    const config = {
      method: 'post',
      params: {
        email
      }
    }

    const { data } = await api('/api/me/passwordReset', config)

    return data
  }

  return useMutation({
    mutationFn: handleMutation,
    mutationKey: authMutationKeys.RESET_PASSWORD_MUTATION,
    retry: 0
  })
}
